var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "solutions-area section-width ptb-100" }, [
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "section-title" }, [
        _c("h2", [_vm._v(_vm._s(_vm.$t("navbar.menu_1_5")))]),
        _c("p", [
          _vm._v(
            " Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incidiunt labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida. "
          )
        ])
      ]),
      _c("section", { staticClass: "blog-area pb-70" }, [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "facility-section block1" }, [
            _c(
              "ul",
              { staticClass: "row" },
              _vm._l(_vm.hotels, function(hotel, index) {
                return _c("li", { key: index, staticClass: "card mb-3" }, [
                  _c(
                    "div",
                    {
                      staticClass: "row no-gutters",
                      class: { "flex-row-reverse": index % 2 === 1 }
                    },
                    [
                      _c("div", { staticClass: "col-md-4" }, [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/project_images/accommodation/" +
                              hotel.image),
                            alt: "Image"
                          }
                        })
                      ]),
                      _c("div", { staticClass: "col-md-8" }, [
                        _c("div", { staticClass: "card-body text-left" }, [
                          _c("h5", { staticClass: "card-title" }, [
                            _vm._v(" " + _vm._s(_vm.$t(hotel.titleKey)) + " ")
                          ]),
                          _c("p", {
                            staticClass: "card-text",
                            domProps: {
                              innerHTML: _vm._s(_vm.$t(hotel.contentKey))
                            }
                          }),
                          _vm._m(0, true)
                        ])
                      ])
                    ]
                  )
                ])
              }),
              0
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "card-text" }, [
      _c("small", { staticClass: "text-muted" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }